export default __webpack_public_path__ + "static/Group 172-a6f00818da1e95e6dbc81eaf215f7216.png";